"use client";
import { Dialog } from "@base-ui/react";
import { Menu } from "@base-ui/react/menu";
import { Flag, MoreHorizontal, Pencil } from "lucide-react";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { reportTopicAction } from "@/actions/forum.action";
import { Button } from "@/components/ui/button";

interface Props {
  topicId: string;
  isOwner: boolean;
}

const TopicActionsMenu = ({ topicId, isOwner }: Props) => {
  const router = useRouter();
  const [reportOpen, setReportOpen] = useState(false);

  const handleReport = async () => {
    await reportTopicAction(topicId);
    setReportOpen(false);
  };

  return (
    <>
      <Menu.Root>
        <Menu.Trigger render={<Button size="icon-sm" variant="ghost" />}>
          <MoreHorizontal className="size-5 stroke-neutral-400" />
        </Menu.Trigger>
        <Menu.Portal>
          <Menu.Positioner align="end" sideOffset={4}>
            <Menu.Popup className="min-w-40 rounded-xl border border-neutral-200 bg-white shadow-lg py-1 outline-none z-50">
              {isOwner ? (
                <Menu.Item
                  className="flex items-center gap-2 px-3 py-2 text-sm text-neutral-700 cursor-pointer hover:bg-neutral-50 data-[highlighted]:bg-neutral-50 outline-none"
                  onClick={() => router.push(`/forum/topic/${topicId}/edit`)}
                >
                  <Pencil className="size-4 stroke-neutral-400" />
                  Düzenle
                </Menu.Item>
              ) : (
                <Menu.Item
                  className="flex items-center gap-2 px-3 py-2 text-sm text-neutral-700 cursor-pointer hover:bg-neutral-50 data-[highlighted]:bg-neutral-50 outline-none"
                  onClick={() => setReportOpen(true)}
                >
                  <Flag className="size-4 stroke-neutral-400" />
                  Bildir
                </Menu.Item>
              )}
            </Menu.Popup>
          </Menu.Positioner>
        </Menu.Portal>
      </Menu.Root>

      <Dialog.Root onOpenChange={setReportOpen} open={reportOpen}>
        <Dialog.Portal>
          <Dialog.Backdrop className="fixed inset-0 bg-black/40 transition-all duration-150 data-starting-style:opacity-0 data-ending-style:opacity-0" />
          <Dialog.Popup className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-sm bg-white rounded-2xl p-6 shadow-xl outline-none transition-all duration-150 data-starting-style:scale-90 data-starting-style:opacity-0 data-ending-style:scale-90 data-ending-style:opacity-0">
            <div className="flex flex-col gap-4">
              <div className="flex items-center justify-between">
                <Dialog.Title className="text-lg font-semibold text-gray-900">
                  Konuyu Bildir
                </Dialog.Title>
                <Dialog.Close
                  className="text-sm font-medium text-gray-500 hover:text-gray-700 cursor-pointer"
                  render={<button type="button" />}
                >
                  ✕
                </Dialog.Close>
              </div>
              <Dialog.Description className="text-sm text-gray-500">
                Bu konuyu şikayet etmek istediğinizden emin misiniz?
              </Dialog.Description>
              <div className="flex gap-2 justify-end">
                <Dialog.Close
                  render={<Button size="sm" type="button" variant="outline" />}
                >
                  Vazgeç
                </Dialog.Close>
                <Button onClick={handleReport} size="sm" type="button">
                  Bildir
                </Button>
              </div>
            </div>
          </Dialog.Popup>
        </Dialog.Portal>
      </Dialog.Root>
    </>
  );
};

export default TopicActionsMenu;
